import { AtsCandidateSourceCategoriesEnum } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export enum CandidateSources {
  Organic = 'organic',
  ManuallyAdded = 'manually_added',
  Employee = 'employee',
  Imported = 'imported',
  Referred = 'referred',
  SpontaneousApplication = 'spontaneous_application',
  AISuggestion = 'ai_suggestion',

  // services
  HelloWork = 'hellowork',
  Indeed = 'indeed',
  JobPosting = 'jobposting',
  JobTarget = 'JobTarget',
  Join = 'JOIN',
  Linkedin = 'linkedin',
  Vonq = 'vonq',
  WelcomeToTheJungle = 'welcome_to_the_jungle',
}

// Source name comes translated from the Backend in the property 'label' only for default sources
// See components/ats/app/public/ats/default_sources.rb file
// Note the CandidateSources list don't match Ats::DefaultSources list
// Please consider unify them in only one place, probably in the backend to serve the translation to the Public API too.
export const getSourceLabel = (source: string | null | undefined) => {
  if (!source) {
    return '-'
  }

  switch (source) {
    case CandidateSources.Organic:
      return i18n.t('ats.source_options.organic')
    case CandidateSources.ManuallyAdded:
      return i18n.t('ats.source_options.manually_added')
    case CandidateSources.Employee:
      return i18n.t('ats.source_options.employee')
    case CandidateSources.Imported:
      return i18n.t('ats.source_options.imported')
    case CandidateSources.Referred:
      return i18n.t('ats.source_options.referred')
    case CandidateSources.SpontaneousApplication:
      return i18n.t('ats.source_options.spontaneous_application')
    case CandidateSources.HelloWork:
      return 'HelloWork'
    case CandidateSources.Indeed:
      return 'Indeed'
    case CandidateSources.JobPosting:
      return 'JobPosting'
    case CandidateSources.JobTarget:
      return 'JobTarget'
    case CandidateSources.Join:
      return 'JOIN'
    case CandidateSources.Linkedin:
      return 'LinkedIn'
    case CandidateSources.Vonq:
      return 'VONQ'
    case CandidateSources.WelcomeToTheJungle:
      return 'Welcome to the Jungle'
    case CandidateSources.AISuggestion:
      return i18n.t('ats.source_options.ai_suggestion')
    default:
      return capitalize(source)
  }
}

export const getCandidateSourceCategoryLabel = (category: AtsCandidateSourceCategoriesEnum) => {
  switch (category) {
    case 'job_board':
      return i18n.t('ats.manage_sources_customization.categories.job_board')
    case 'agency_or_external_recruiter':
      return i18n.t('ats.manage_sources_customization.categories.agency_or_external_recruiter')
    case 'event':
      return i18n.t('ats.manage_sources_customization.categories.event')
    case 'social_media':
      return i18n.t('ats.manage_sources_customization.categories.social_media')
    case 'referral':
      return i18n.t('ats.manage_sources_customization.categories.referral')
    case 'internal':
      return i18n.t('ats.manage_sources_customization.categories.internal')
    case 'organic':
      return i18n.t('ats.manage_sources_customization.categories.organic')
    case 'manually_added':
      return i18n.t('ats.manage_sources_customization.categories.manually_added')
    case 'system':
      return i18n.t('ats.manage_sources_customization.categories.system')
  }
}

export const candidateSourceCategoryOptions = () => [
  {
    label: getCandidateSourceCategoryLabel('job_board'),
    value: 'job_board',
  },
  {
    label: getCandidateSourceCategoryLabel('agency_or_external_recruiter'),
    value: 'agency_or_external_recruiter',
  },
  {
    label: getCandidateSourceCategoryLabel('event'),
    value: 'event',
  },
  {
    label: getCandidateSourceCategoryLabel('social_media'),
    value: 'social_media',
  },
  {
    label: getCandidateSourceCategoryLabel('referral'),
    value: 'referral',
  },
  {
    label: getCandidateSourceCategoryLabel('internal'),
    value: 'internal',
  },
]
